import url from './url';

const AppConsts = {
  userManagement: {
    defaultAdminUserName: 'admin',
  },
  localization: {
    defaultLocalizationSourceName: 'Giganaut',
  },
  authorization: {
    encrptedAuthTokenName: 'enc_auth_token',
  },
  appBaseUrl: 'http://localhost:12345',
  appId: "b47a3310-e6b0-4d80-9514-47d520f3e26d",
  remoteServiceBaseUrl: url,
  brand: {
    firstWord: 'Giganaut',
    secondWord: '',
    logo: 'mdi-brain',
    primaryColor: '#3f51b5',
    secondaryColor: '#ff5c00',
  },
};
export default AppConsts;
